export default __webpack_public_path__ + "static/media/letsikringvedkritisksygdom.2d169514.jpg";